import { formatNumber, percentOfPopulation } from 'Utils'
import { Fragment, useState } from 'react'
import styled from 'styled-components'
import { useEventListener } from 'usehooks-ts'

export const DynamicText = ({ locale = 'de' }: { locale?: 'de' | 'fr' }) => {
  const [selectedNameData, setSelectedNameData] = useState<CurrentName>(
    window.nachnamen.selectedNameData ? window.nachnamen.selectedNameData : null
  )
  const [closestNames, setClosestNames] = useState<CurrentName[]>(
    window.nachnamen.closestNames ? window.nachnamen.closestNames : []
  )

  useEventListener('name_changed' as any, () => {
    setSelectedNameData(window.nachnamen.selectedNameData)
    setClosestNames(window.nachnamen.closestNames)
  })

  return (
    <DynamicTextRoot>
      {selectedNameData && locale === 'de' && (
        <>
          Ihren Nachnamen <b>{selectedNameData.name}</b> gibt es in der Schweiz{' '}
          <b>{formatNumber(selectedNameData.count)}-mal</b>. Das entspricht{' '}
          <b>
            {percentOfPopulation(selectedNameData.count)
              .replace('%', ' Prozent')
              .replace('<', locale === 'de' ? ' weniger als' : ' moins de')}
          </b>{' '}
          der Gesamt&shy;bevölkerung und reicht für{' '}
          <b>Rang {formatNumber(selectedNameData.rank)}</b> in der landesweiten
          Tabelle.{' '}
          {closestNames.length === 0 ? (
            <>Kein Name ist ähnlich häufig.</>
          ) : (
            <>
              {closestNames.length === 1 ? (
                <>
                  Ähnlich häufig gibt es zum Beispiel den Namen{' '}
                  {closestNames[0].name}.
                </>
              ) : (
                <>
                  Ähnlich häufig gibt es zum Beispiel die Namen{' '}
                  {closestNames.map((name, i) => (
                    <Fragment key={'dynamictext_name_' + i}>
                      {name.name}
                      {i === closestNames.length - 2
                        ? ' und '
                        : i < closestNames.length - 1
                        ? ', '
                        : ''}
                    </Fragment>
                  ))}
                  .
                </>
              )}
            </>
          )}
        </>
      )}
      {selectedNameData && locale === 'fr' && (
        <>
          Le nom de famille <b>{selectedNameData.name}</b> existe{' '}
          <b>{formatNumber(selectedNameData.count)} fois</b> en Suisse. Cela
          correspond à{' '}
          <b>
            {percentOfPopulation(selectedNameData.count).replace(
              '<',
              ' moins de'
            )}
          </b>{' '}
          de la population totale. Il arrive en{' '}
          <b>
            {' '}
            {formatNumber(selectedNameData.rank)}
            {selectedNameData.rank === 1 ? 're' : 'e'}
          </b>{' '}
          position du tableau national.{' '}
          {closestNames.length === 0 ? (
            <>Aucun nom n'est aussi fréquent.</>
          ) : (
            <>
              {closestNames.length === 1 ? (
                <>
                  Le nom {closestNames[0].name}, par exemple, est tout aussi
                  fréquent.
                </>
              ) : (
                <>
                  Les noms{' '}
                  {closestNames.map((name, i) => (
                    <Fragment key={'dynamictext_name_' + i}>
                      {name.name}
                      {i === closestNames.length - 2
                        ? ' et '
                        : i < closestNames.length - 1
                        ? ', '
                        : ''}
                    </Fragment>
                  ))}{' '}
                  par exemple, sont tout aussi fréquents.
                </>
              )}
            </>
          )}
        </>
      )}
    </DynamicTextRoot>
  )
}

const DynamicTextRoot = styled.div`
  font-family: var(--font-serif);
  font-size: 18px;
  line-height: 30px;
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  @media screen and (max-width: 711px) {
    margin-left: 20px;
    margin-right: unset;
    max-width: calc(100vw - 40px);
    font-size: 17px;
    line-height: 28px;
  }
`
